import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { QUERY_KEY } from '~common';
import { getRequest } from '~services';
import { inMemoryJWTService } from '~services/jwt.service';
import { UserSubscription } from '~types/subscription.type';

export interface UserSubscriptionResponse {
  subscription: UserSubscription | null;
}

export const useQueryGetUserSubscriptionByPhoneNumber = (
  reqParams: {
    phoneNumber: string;
  },
  options?: Omit<
    UseQueryOptions<
      UserSubscriptionResponse,
      AxiosError<Record<string, string>>,
      UserSubscriptionResponse,
      (QUERY_KEY | string)[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const getUserSubscription = (): Promise<UserSubscriptionResponse> =>
    getRequest({
      path: 'api/subscription/by-phone-number',
      params: reqParams,
    });

  const { enabled = true, ...restOptions } = options ?? {};

  return useQuery(
    [QUERY_KEY.GET_USER_SUBSCRIPTION_BY_PHONE_NUMBER, reqParams.phoneNumber],
    () => getUserSubscription(),
    {
      // Token and phone number are hard preconditions, not defaults: a caller
      // passing `enabled` narrows the query, it must never widen it into a call
      // with no auth or an empty phone number.
      enabled:
        enabled &&
        !!inMemoryJWTService.getCurrentToken() &&
        !!reqParams.phoneNumber,
      ...restOptions,
    },
  );
};
